module.exports = __webpack_public_path__ + "static/media/Spinner.df0a97e9.svg";